import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog'
import { FileUpload, FileUploadBeforeUploadParams, FileUploadErrorParams, FileUploadHandlerParam, FileUploadSelectParams, FileUploadUploadParams } from 'primereact/fileupload';
import React, { FC, useRef, useState } from 'react'
import { tawreedTranslationService } from '../../../../common/translations';
import { PrimeIcons } from 'primereact/api';

export interface ConfirmDeleteMyAccountProps {
    visible: boolean;

    hide: () => void;
    accept: () => void
}

export const ConfirmDeleteMyAccount: FC<ConfirmDeleteMyAccountProps> = ({ visible, hide, accept }) => {


    const ImportProductsDialogFooter = () => {
        return (<div>
            <Button label={tawreedTranslationService.translate('lbl_cancel')} icon={PrimeIcons.TIMES} className="p-button-text" disabled={false} onClick={hide} />
            <Button label={tawreedTranslationService.translate('lbl_delete_my_account')} icon={PrimeIcons.TRASH} className='p-button-danger' onClick={accept} disabled={false} />
        </div>);
    }

    return (
        <Dialog style={{ maxWidth: '50%' }} header={tawreedTranslationService.translate('lbl_delete_my_account')} visible={visible} footer={<ImportProductsDialogFooter />} onHide={hide} draggable={false} position="top" closable={false} closeOnEscape={false}>

            <h6 className='font-bold'>{tawreedTranslationService.translate("lbl_delete_7")}</h6>
            <ul className='p-confirm-dialog-message'>
                <li className='my-4 font-bold p-confirm-dialog-message'>{tawreedTranslationService.translate("lbl_delete_8")}</li>
                <li className='my-4 font-bold p-confirm-dialog-message'>{tawreedTranslationService.translate("lbl_delete_9")}</li>
                <li className='my-4 font-bold p-confirm-dialog-message'>{tawreedTranslationService.translate("lbl_delete_10")}</li>
            </ul>
        </Dialog>
    )
}
